module.exports = __webpack_public_path__ + "static/media/ease_to_use.be5edff5.svg";